import LoadingAnimation from "../loading/loading";
import "./single-stat.css";

export const SingleStat = ({ headerTitle, summaryValue, summaryValueColour, complete, loading, error }) => {
	return (
		<div style={{ minHeight: '195px', maxHeight: '195px', overflow: 'hidden' }} className="card border-0 mb-3 bg-gray-800 text-white">
			<div className="card-body h-100">
				<div className="row h-100">
					<div className="col-xl-12 col-lg-12 d-flex flex-column justify-content-center">
						<div className="mb-1 text-gray-500">
							<b>{headerTitle}</b>
							<div
								className={`card-text single-stat-card-value ${error ? "text-red-500" : summaryValueColour}`}
							>
								{error ? (
									<div className="text-red-500" style={{ fontSize: '2.5vh' }}>
										{error}
									</div>
								) : complete ? (
									<>{summaryValue}</>
								) : (
									<LoadingAnimation />
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
